import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportStockAbcCurveRequest } from './StockAbcCurve.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportStockAbcCurve(
  params: QuestReportStockAbcCurveRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/StockAbcCurve`,
    params,
  )) as unknown;

  return result as BlobPart;
}
